import RelativeLinkTrap from './RelativeLinkTrap';

export default RelativeLinkTrap;
